export default "__VITE_ASSET__C1GdlRis__"